export default __webpack_public_path__ + "static/media/listbuilder-flag-selected.3b809775.svg";